import { render, staticRenderFns } from "./PostOrgTree.vue?vue&type=template&id=a4569158&"
import script from "./PostOrgTree.vue?vue&type=script&lang=js&"
export * from "./PostOrgTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports